import 'reflect-metadata';
import './env-config';

import { pdfjs } from 'react-pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.min.js?url';
import { startApp } from './bootstrap';
import './index.css';

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

// Runs the embed-only guard, then (unless redirecting) FullStory + the React root — see bootstrap.tsx.
startApp({ isDev: import.meta.env.DEV });
